import {Transition} from '@mantine/core';
import type React from 'react';
import {useEffect, useState} from 'react';
import {MdList} from 'react-icons/md';

type Props = {
  openModal: () => void;
  scrollY?: number;
};

// SPの目次ボタン：一定のスクロールでボタンが表示される
export const SpFloatContent: React.FC<Props> = ({openModal, scrollY = 440}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > scrollY) {
        // スクロール位置を調整
        setMounted(true);
      } else {
        setMounted(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <Transition
      mounted={mounted}
      transition="scale-x"
      duration={600}
      timingFunction="ease"
    >
      {(styles) => (
        <div
          className="text-base font-bold flex items-center bg-white w-[80px] rounded-r-16 shadow-modal p-8 sticky top-[76px] z-40 pc:hidden"
          onClick={openModal}
          style={styles}
        >
          <div className="flex h-20 text-primary-1">
            <MdList size={20} /> <span>目次</span>
          </div>
        </div>
      )}
    </Transition>
  );
};
